import React from 'react';
import PropTypes from 'prop-types';
import IconWithText from 'components/Widgets/IconWithText';

export default function Title({ title, icon }) {
  return (
    <div className="m-2">
      {' '}
      <IconWithText
        iconClassName="small-icon"
        iconStyle={{ backgroundImage: `url(${icon})`, backgroundSize: 'cover', backgroundColor: 'inherit' }}
      >
        <div>{title}</div>
      </IconWithText>
    </div>
  );
}

Title.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
};
